'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _checklistConstants = require('./checklistConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib


// Constants


/**
 * Render the following structure:
 * <ul className="checklist-ul">
 *     <li>...</li>
 *     ...
 * </ul>
 */
exports.default = Immutable.Map(_defineProperty({}, _checklistConstants.CHECKLIST_BLOCK_TYPE, {
    element: 'li',
    wrapper: _react2.default.createElement('ul', { className: 'checklist-ul' })
}));


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/checklist/blockRenderMap.js
// module id = 1718
// module chunks = 0